import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b8628a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "our-stories has-background" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("header", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "subtitle subtitle--left--mobile text-primary" }, "Our Work"),
    /*#__PURE__*/_createElementVNode("h2", { class: "our-stories__title" }, [
      /*#__PURE__*/_createTextVNode(" We’re here to revolutionise the world of "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("IT Consulting ")
    ]),
    /*#__PURE__*/_createElementVNode("p", { class: "lead" }, " Learn how we improved our clients’ IT landscape by delivering on their core technological needs. ")
  ])
], -1))
const _hoisted_3 = { class: "container slider-container" }
const _hoisted_4 = {
  key: 0,
  class: "container text-center"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Explore all success stories ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_images_slider = _resolveComponent("images-slider")!
  const _component_icon_arrow_link = _resolveComponent("icon-arrow-link")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.listImages?.length > 0)
        ? (_openBlock(), _createBlock(_component_images_slider, {
            key: 0,
            class: "stories",
            images: _ctx.listImages,
            options: _ctx.options,
            "show-title": true,
            id: 'stories'
          }, null, 8, ["images", "options"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showMoreBtn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/success-stories",
            class: "btn btn--link"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createVNode(_component_icon_arrow_link)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}